import React from 'react'
import './style.scss'
import smoothScroll from 'smoothscroll'

const ArrowCta = ({text, link}) => {
  function clickHandler (linkID) {
    const id = linkID.split('#')[1]
    const destination = document.getElementById(id)
    smoothScroll(destination)
  }

  return (
    <div className='arrowCta-wrapper'>
      <a href={link} className='arrowCta-element' onClick={() => clickHandler(link)}>{text}</a>
    </div>
  )
}

export default ArrowCta



// WEBPACK FOOTER //
// ./src/components/arrow-cta/index.js